import team0 from '../Images/slide7.jpeg'
import team1 from '../Images/team1.jpeg'
import team2 from '../Images/team2.jpeg'
import team3 from '../Images/team3.jpeg'

const team = [
    {bgImg: team0},
    {bgImg: team1},
    {bgImg: team2},
    {bgImg: team3},
]

export default team